import { render, staticRenderFns } from "./detailItem.vue?vue&type=template&id=aac8ee6c&scoped=true"
import script from "./detailItem.vue?vue&type=script&lang=js"
export * from "./detailItem.vue?vue&type=script&lang=js"
import style0 from "./detailItem.vue?vue&type=style&index=0&id=aac8ee6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac8ee6c",
  null
  
)

export default component.exports